import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import Et3Button from "../../../../../../core/et3-button";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import InvestigateButton from "../../../../../../core/et3-shared-components/action-buttons/AddToInvestigationButton";
import WarningButton from "../../../../../../core/et3-shared-components/action-buttons/WarningButton";
import getCorePopUpStore from "../../../../../../stores/core/core-popup-store";
import { reduce } from "et3-type-guards";

const UserActionButtons = withLiteObserverAndTheme((props) => {
  const userID = getUserAdvancedStore().currentUserId.get();
  const userUUID = reduce(
    () => getUserAdvancedStore().userData.get(userID).userUUID,
    ""
  );
  const { theme } = props;
  const { colors } = theme;
  const isActionButtonsDisabled =
    getUserAdvancedStore().isActionButtonsDisabled.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={250}
      height={260}
      fDirection="column"
      alignItems="center"
      justifyContent="space-between"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <WarningButton
        fromPage="USER_ADVANCED"
        extraData={{
          userID,
          userUUID,
          reportedUUID: "",
          reportID: -1,
          reportedID: -1,
          secondPartyID: -1
        }}
        style={{}}
        disabled={isActionButtonsDisabled}
        size="MEDIUM"
      />
      <InvestigateButton
        fromPage="USER_ADVANCED"
        extraData={{
          userID,
          userUUID,
          reportedID: -1,
          reportedUUID: "",
          reportID: -1,
          secondPartyID: -1
        }}
        style={{}}
        disabled={isActionButtonsDisabled}
      />
      <Et3Button
        isEnabled={true}
        onClick={async () => {
          getCorePopUpStore().openConfirmationPopUps("RESET_ACCOUNT_POPUP");
        }}
        type="WARN"
        size="MEDIUM"
        text="RESET_ACCOUNT"
      />
    </ET3Div>
  );
});
export default UserActionButtons;
